import { makeObservable, observable } from 'mobx'
import { authenticationStore } from '~/stores'
import { FormModel, SubmitResult } from '~/ui/form'

export default class LoginFormModel implements FormModel {

  constructor() {
    makeObservable(this)
  }

  @observable
  public email: string = ''

  @observable
  public pin: string = ''

  public get maySubmit() {
    if (this.email.trim().length === 0) { return false }
    if (this.pin.length < 5) { return false }
    return true
  }

  public async submit(): Promise<SubmitResult> {
    return await authenticationStore.logIn({
      email: this.email.trim(),
      pin:   this.pin,
    })
  }

}